import { render, staticRenderFns } from "./BindFailed.vue?vue&type=template&id=05f5c3f2&scoped=true&"
import script from "./BindFailed.vue?vue&type=script&lang=js&"
export * from "./BindFailed.vue?vue&type=script&lang=js&"
import style0 from "./BindFailed.vue?vue&type=style&index=0&id=05f5c3f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f5c3f2",
  null
  
)

export default component.exports